import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// import { ReactComponent as Call } from '../../assets/icons/profile/call.svg';
// import { ReactComponent as Chat } from '../../assets/icons/profile/chat.svg';
import { ReactComponent as TimerIcon } from '../../assets/icons/clock-icon.svg';
import { ReactComponent as FacilityArrow } from '../../assets/icons/profile/facilityNavigate.svg';
import { ReactComponent as FileIcon } from '../../assets/icons/profile/file.svg';
import { ReactComponent as ImageEdit } from '../../assets/icons/profile/image-edit.svg';
import { ReactComponent as Logout } from '../../assets/icons/profile/logout.svg';
import { ReactComponent as ProfileEdit } from '../../assets/icons/profile/profileEdit.svg';
// import { ReactComponent as CustomerCare } from '../../assets/icons/profile/support-icon.svg';
import { ReactComponent as Tick } from '../../assets/icons/tick-icon.svg';
import { ReactComponent as Trash } from '../../assets/icons/Trash.svg';
import ProfileImage from '../../assets/images/profile.jpg';
import { brandIcons,currentBranding } from '../../config/branding';
import {branding} from "../../config/enum"
import {
  GetAccount,
  ProfileInterface,
  updateEmail,
  updatePhoneNumber,
  UpdateStripeId,
} from '../../interface/profile.interface';
import { useAppDispatch } from '../../redux/hooks';
import { setNotificationDetails } from '../../redux/slice/NotificationSlice';
import { fetchSessionUser } from '../../redux/slice/UserManagementSlice';
import MyButton from '../../shared-components/button/Button';
// import LanguageDropDown from '../../shared-components/custom-language-dropDown/languageDropDown';
import CustomInput from '../../shared-components/custom-input/CustomInput';
import CustomPhoneNumber from '../../shared-components/custom-phone-number-input/CustomPhoneNumberInput';
import ModalBox from '../../shared-components/modal-box/ModalBox';
import PageTitle from '../../shared-components/page-title/PageTitle';
import { getCookie, removeCookie } from '../../shared-functions/Cookies';
import {decodeJWT} from '../../shared-functions/JWTDocodeFunction';
import { getLocalStorageItem, removeLocalStorageItem } from '../../shared-functions/LocalStorage';
import {
  emailValidation,
  integerValidation,
  phoneNumberValidation,
  stringValidation,
} from '../../shared-functions/Validation';
import account from '../../utils/api/account';
import auth from '../../utils/api/auth';
import profileApi from '../../utils/api/profile';
import userApi from '../../utils/api/users';

import RevenueDetails from './components/revenue-details';
import RevenueHistory from './components/revenue-history';
import LogoutCancelWarning from './logout';
import WithdrawalHistory from './withdrawalHistory';

interface ModalBoxDetail {
  title: string | null;
  content: JSX.Element | null;
  notificationModal: boolean;
  header: boolean;
}

/**
 * profile main component function
 * @returns
 */
function Profile() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const accountVerificationStatus = getLocalStorageItem('accountVerificationStatus');
  const fileInputReference = useRef<HTMLInputElement | null>(null);
  const InputReference = useRef<HTMLInputElement | null>(null);
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [editEmailMode, setEditEmailMode] = useState<boolean>(false);
  const [accountId, setAccountId] = useState<string | null>(null);
  const [emailForm, setEmailForm] = useState<{
    email: string;
    otp: number | null;
    buttonLoader?: boolean;
  }>({
    email: '',
    otp: null,
    buttonLoader: false,
  });
  const [editPhoneNumberMode, setEditPhoneNumberMode] = useState<boolean>(false);
  const [phoneNumberForm, setPhoneNumberForm] = useState<{
    phoneNumber: string;
    countryCode: string;
    otp: number | null;
    buttonLoader?: boolean;
  }>({
    phoneNumber: '',
    countryCode: currentBranding === 'energic' ? '966' : '1',
    otp: null,
    buttonLoader: false,
  });
  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    content: null,
    notificationModal: false,
    header: false,
  });

  const [editStripeIDMode, setEditStripeIDMode] = useState<boolean>(false);

  const [accountData, setAccountData] = useState<GetAccount>({
    id: '', // Default value for id
    stripePaymentId: '', // Default value for stripePaymentId
  });

  const [stripeIDForm, setStripeIDForm] = useState<{
    stripePaymentId: string;
    buttonLoader?: boolean;
  }>({
    stripePaymentId: '',
    buttonLoader: false,
  });

  const [userProfile, setUserProfile] = useState<ProfileInterface>({});

  const intervalReference = useRef<NodeJS.Timeout | null>(null);
  const [resendTimer, setResendTimer] = useState<number>(0);

    useEffect(() => {
    const accessToken = getCookie('ev-access-token');
    let id = getCookie('accountCustomId');
    if (accessToken) {
      const payload = decodeJWT(accessToken);
      if (payload?.accountCustomId) {
        id = payload.accountCustomId;
      }
    }
    setAccountId(id);
  }, []);

  /**
   * documentEdit
   */
  const documentEdit = () => {
    if (InputReference.current) {
      InputReference.current.click();
    }
  };
  /**
   * profileEdit
   */
  const profileEdit = () => {
    if (fileInputReference.current) {
      fileInputReference.current.click();
    }
  };

  /**
   * history
   */
  const withdrawalHistoryChange = () => {
    setModalBoxDetail({
      title: 'Withdrawal History',
      content: <WithdrawalHistory handleCancel={() => setModalBoxStatus('close')} />,
      notificationModal: false,
      header: true,
    });
    setModalBoxStatus('open');
  };

  /**
   * Function to handle logout API and token deletion from cookies
   */
  const handleTokenDelete = () => {
    const accessToken = getCookie('ev-access-token');
    auth
      .logout({ accessToken })
      .then(() => {
        removeCookie('ev-refresh-token');
        removeCookie('ev-access-token');
        removeLocalStorageItem('accountVerificationStatus');
        navigate('../../');
      })
      .catch((error) => {
        console.error(error);
      });
  };

  /**
   * Logout popup open functionality
   */
  const handleLogout = () => {
    setModalBoxDetail({
      title: '',
      content: (
        <LogoutCancelWarning
          title="Are you sure want to Logout?"
          description="Any unsaved changes will be lost"
          cancelButtonLabel="Cancel"
          cancelButtonOnClick={() => setModalBoxStatus('close')}
          submitButtonLabel="OK"
          submitButtonOnClick={handleTokenDelete}
        />
      ),
      notificationModal: true,
      header: false,
    });
    setModalBoxStatus('open');
  };

  /**
   * Get the profile details in function
   */
  const fetchProfileData = () => {
    Promise.allSettled([
      profileApi.getProfileDetails(),
      profileApi.getTotalChargingStation(),
      profileApi.getTotalChargingPoints(),
      profileApi.getTotalConnectors(),
    ])
      .then((response: { status: string; value?: any }[]) => {
        response.forEach((value) => {
          if (value.status === 'fulfilled') {
            setUserProfile((previous) => ({
              ...previous,
              ...value.value.data,
            }));
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * Function to update profile image
   */
  const handleUpdateProfileImage = async (file: File) => {
    try {
      // Send the formData to your API
      await userApi.editUserProfileImage({ profileImage: file });
      fetchProfileData();
      dispatch(fetchSessionUser(userProfile._id || ''));
    } catch (error) {
      console.error('Error updating profile image:', error);
    }
  };

  /**
   * Function to update government Id
   */
  const handleUpdateGovernmentId = async (file: File) => {
    try {
      // Send the formData to your API
      await userApi.editUserGovernmentId({ governmentId: file });
      fetchProfileData();
    } catch (error) {
      console.error('Error updating profile image:', error);
    }
  };

  /**
   * Function to handle email change
   */
  const handleEmailFormChange = (name: string, value: string | number) => {
    setEmailForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Function to toggle email edit mode
   */
  const toggleEmailInput = () => {
    setEditEmailMode(!editEmailMode);
  };

  /**
   * Function to handle Resend OTP timer
   */
  const startResendTimer = () => {
    // Clear any previous interval before starting a new one
    if (intervalReference.current) clearInterval(intervalReference.current);

    setResendTimer(30); // Reset to 60 seconds
    intervalReference.current = setInterval(() => {
      setResendTimer((previous) => {
        if (previous <= 1) {
          if (intervalReference.current) clearInterval(intervalReference.current); // Clear interval at the end
          return 0;
        }
        return previous - 1;
      });
    }, 1000);
  };

  /**
   * Function to handle phone number change
   */
  const handlePhoneNumberFormChange = (name: string, value: string | number) => {
    setPhoneNumberForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };


  /**
   * Function to toggle phone number edit mode
   */
  const togglePhoneNumberInput = () => {
    setEditPhoneNumberMode(!editPhoneNumberMode);
  };


    /**
     * Function to handle changes in the Stripe ID form.
     * Updates the state of the Stripe ID form with the provided name and value.
     * @param {string} name - The name of the form field to update.
     * @param {string | number} value - The value to set for the specified form field.
     */
  const handlestripeIDFormChange = (name: string, value: string | number) => {
    setStripeIDForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Function to toggle the edit mode for the Stripe ID input.
   * Toggles the state of `editStripeIDMode` between true and false.
   */
  const toggleStripeIDInput = () => {
    setEditStripeIDMode(!editStripeIDMode);
  };


  /**
   * Function to update email
   */
  const submitUpdateEmail = (purpose: string) => {
    const body: updateEmail = {
      email: emailForm.email,
      purpose,
      otpType: 'updateEmail',
    };
    if (purpose === 'sendOtp') {
      if (resendTimer === 0) {
        startResendTimer();
      }
    } else if (purpose === 'verifyOtp') {
      setEmailForm((previous) => ({
        ...previous,
        buttonLoader: true,
      }));
      body.otp = emailForm.otp;
    }

    account
      .updateEmailPhoneNumber(body)
      .then(() => {
        setEmailForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));

        if (purpose === 'verifyOtp') {
          setUserProfile((previous) => ({
            ...previous,
            email: emailForm.email,
          }));
          dispatch(
            setNotificationDetails({
              type: 'success',
              notificationDetails: {
                statusCode: 200,
                message: 'Email Updated Successfully',
              },
            }),
          );
          toggleEmailInput();
        }
      })
      .catch((error) => {
        setEmailForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };



  /**
   * Function to update email
   */
  const submitUpdatePhoneNumber = (purpose: string) => {
    const body: updatePhoneNumber = {
      phoneNumber: phoneNumberForm.phoneNumber,
      countryCode: phoneNumberForm.countryCode,
      purpose,
      otpType: 'updatePhoneNumber',
    };
    if (purpose === 'sendOtp') {
      if (resendTimer === 0) {
        startResendTimer();
      }
    } else if (purpose === 'verifyOtp') {
      setPhoneNumberForm((previous) => ({
        ...previous,
        buttonLoader: true,
      }));
      body.otp = phoneNumberForm.otp;
    }

    account
      .updateEmailPhoneNumber(body)
      .then(() => {
        setPhoneNumberForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));

        if (purpose === 'verifyOtp') {
          setUserProfile((previous) => ({
            ...previous,
            countryCode: phoneNumberForm.countryCode,
            phoneNumber: phoneNumberForm.phoneNumber,
          }));
          dispatch(
            setNotificationDetails({
              type: 'success',
              notificationDetails: {
                statusCode: 200,
                message: 'Phone number Updated Successfully',
              },
            }),
          );
          togglePhoneNumberInput();
        }
      })
      .catch((error) => {
        setPhoneNumberForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  /**
   * Function to fetch the Stripe ID for a user.
   * Calls the `GetStripeID` API and updates the state with the fetched data.
   * @async
   * @function fetchAccount
   * @returns {Promise<void>} - A promise that resolves when the data is fetched and state is updated.
   */
  const fetchAccount = async (): Promise<void> => {
    try {
      const response = await account.getAccount({}); // Call the function properly
      const  accountsData = response?.data || {}; // Use an empty object as the fallback
      setAccountData(accountsData); // Update the state with the fetched data
    } catch (error) {
      console.error('Error fetching Stripe ID:', error);
    }
  };

  /**
   * Function to handle updating the Stripe ID.
   * Validates the input and sends the update request to the API.
   */
  const updateStripeId = () => {
    // Validate the Stripe ID

    if (!stripeIDForm.stripePaymentId) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 400,
            message: 'Stripe ID is required',
          },
        }),
      );
      return;
    }

    if (!stringValidation(1, 100, stripeIDForm.stripePaymentId)) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 400,
            message: 'Stripe ID must be between 1 and 100 characters',
          },
        }),
      );
      return;
    }

    // Set the button loader to true
    setStripeIDForm((previous) => ({
      ...previous,
      buttonLoader: true,
    }));

    // Prepare the request body
    const body: UpdateStripeId = {
      stripePaymentId: stripeIDForm.stripePaymentId, // Use the correct property name
    };

    // Call the API to update the Stripe ID
    account
      .updateStripeID(body)
      .then(() => {
        setStripeIDForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));
        dispatch(
          setNotificationDetails({
            type: 'success',
            notificationDetails: {
              statusCode: 200,
              message: 'Stripe ID updated successfully',
            },
          }),
        );
        toggleStripeIDInput(); // Close the edit mode
        // Optionally update the user profile state
        setUserProfile((previous) => ({
          ...previous,
          stripePaymentId: stripeIDForm.stripePaymentId,
        }));
        setAccountData((previous) => ({
          ...previous,
          stripePaymentId: stripeIDForm.stripePaymentId || '', // Ensure a fallback value if undefined
        }));
      })
      .catch((error) => {
        setStripeIDForm((previous) => ({
          ...previous,
          buttonLoader: false,
        }));
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 500,
              message: error?.response?.data?.message || 'Failed to update Stripe ID',
            },
          }),
        );
      });
  };

  useEffect(() => {
    fetchProfileData();
    fetchAccount();
  }, []);

  return (
    <div className="profile-main-container">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        header={modalBoxDetail.header}
        notification={modalBoxDetail.notificationModal}
      />
      <div className="profile-header">
        <div className="profile-title">
          <PageTitle title="Profile" />
        </div>
        <div className="profile-header-buttons">
          <div className="language-dropdown">{/* <LanguageDropDown /> */}</div>
          <div className="logout-button">
            <MyButton
              label="Logout"
              disableHoverEffect
              buttonType="back"
              onClickFunc={handleLogout}
              svgBackIcon={<Logout />}
            />
          </div>
        </div>
      </div>
      <div className="profile-content-container">
        <div className="profile-details-container">
          <div className="profile-details">
            <div className="profile-details-edit">
              <div className="profile-image-wrap">
                <img
                  src={userProfile?.profileImage?.signedUrl || ProfileImage}
                  alt="Preview"
                  className="profile-image"
                />
                <div className="image-upload-icon" role="presentation" onClick={profileEdit}>
                  <ImageEdit />
                  <input
                    onChange={(event) => {
                      const file = event.target.files ? event.target.files[0] : null;
                      if (file) {
                        handleUpdateProfileImage(file);
                      }
                    }}
                    type="file"
                    accept="image/jpeg, image/png, image/gif" // Only allows jpg, png, and gif
                    ref={fileInputReference}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>
              <div className="profile-content-list">
                <div className="profile-name">
                  <div className="name-active">
                    <p>{userProfile.name}</p>
                    {accountVerificationStatus === 'approved' && (
                      <span>
                        <Tick />
                      </span>
                    )}
                  </div>
                  {/* <p className="document-id">ENR0089</p> */}
                  <div className="government-id-edit">
                    <p>Government ID:</p>
                    <div className="profile-document">
                      <span>
                        <FileIcon />
                      </span>
                      <p>{userProfile?.governmentId?.[0]?.fileName}</p>
                    </div>
                    <div className="docs-edit" role="presentation" onClick={documentEdit}>
                      <ProfileEdit />
                      <input
                        onChange={(event) => {
                          const file = event.target.files ? event.target.files[0] : null;
                          if (file) {
                            handleUpdateGovernmentId(file);
                          }
                        }}
                        ref={InputReference}
                        type="file"
                        accept="application/pdf" // Only allows PDF files                                              ref={fileInputReference}
                        style={{ display: 'none' }}
                      />
                    </div>
                  </div>
                  <div>
                    <p>Account ID: {accountId}</p>
                  </div>
                </div>
              </div>
              {/* <div className="profile-edit-icon">
                                <div
                                    className="icon"
                                    onClick={profileEdit}
                                    role="presentation"
                                >
                                    <ProfileEdit />
                                </div>
                            </div> */}
            </div>
            <div className="profile-facilities-details">
              <div className="profile-facilities-header">
                <div className="facility-icon">
                  <brandIcons.facilityIcon />
                </div>
                <p>Facilities</p>
                <div className="facility-navigate-icon">
                  <span>
                    <FacilityArrow />
                  </span>
                </div>
              </div>
              <div className="station-details">
                <div className="facility-count">
                  <p>Total Facilities</p>
                  <span>{userProfile.totalChargingStations}</span>
                </div>
                <div className="facility-count">
                  <p>Total Devices</p>
                  <span>{userProfile.totalChargingPoints}</span>
                </div>
                <div className="facility-count">
                  <p>Total Connectors</p>
                  <span>{userProfile.totalConnectors}</span>
                </div>
              </div>
              <div className="contact-details">
                <div className="contact-header">
                  <div className="contact-icon">
                    <brandIcons.contactIcon />
                  </div>
                  <span>Contact</span>
                </div>
                <div className="contact-content">
                  {!editEmailMode ? (
                    <div className="each-contact-content">
                      <p>Email:</p>
                      <span>{userProfile.email}</span>
                      <ProfileEdit onClick={toggleEmailInput} />
                    </div>
                  ) : (
                    <>
                      <CustomInput
                        inputLabel="Email"
                        type="text"
                        placeholder="Enter email"
                        name="email"
                        value={emailForm.email ?? ''}
                        onChangeValue={handleEmailFormChange}
                        valueRequired
                        error={!emailValidation(emailForm.email ?? '')}
                        // errorMessage="Invalid email"
                        errorMessage={emailForm.email.length === 0 ? 'Email is required' : 'Invalid email' }
                      />
                      <CustomInput
                        inputLabel="Otp"
                        type="number"
                        placeholder="Enter otp"
                        name="otp"
                        value={emailForm.otp ?? ''}
                        onChangeValue={handleEmailFormChange}
                        valueRequired
                        error={!integerValidation(1, 10, emailForm.otp ?? 0)}
                        errorMessage="Invalid otp"
                      />
                      <div className="resend-otp-wrap">
                        <div className="resend-timer-wrap">
                          <span className="resend-icon">
                            <TimerIcon />
                          </span>
                          <span>00:{resendTimer < 10 ? `0${resendTimer}` : resendTimer}</span>
                        </div>
                        <p
                          role="presentation"
                          onClick={() => submitUpdateEmail('sendOtp')}
                          className={`resendOtp ${resendTimer > 0 ? 'disabled' : ''}`}>
                          Send / Resend OTP
                        </p>
                      </div>
                      <div className="form-buttons-wrap">
                        <MyButton label="Cancel" buttonType="back" onClickFunc={toggleEmailInput} />
                        <MyButton
                          label="Update Email"
                          buttonType="submit"
                          onClickFunc={() => submitUpdateEmail('verifyOtp')}
                          disableButton={emailForm.buttonLoader}
                          loading={emailForm.buttonLoader}
                        />
                      </div>
                    </>
                  )}
                  {!editPhoneNumberMode ? (
                    <div className="each-contact-content">
                      <p>Phone:</p>
                      <span>
                        +{userProfile.countryCode} {userProfile.phoneNumber}
                      </span>
                      <ProfileEdit onClick={togglePhoneNumberInput} />
                    </div>
                  ) : (
                    <>
                      <div className="add-user-name-input">
                        <CustomPhoneNumber
                          inputLabel="Phone number"
                          placeholder="Enter phone number"
                          name="phoneNumber"
                          value={phoneNumberForm.phoneNumber}
                          countryCode={phoneNumberForm.countryCode}
                          onChangeValue={handlePhoneNumberFormChange}
                          valueRequired
                          error={!phoneNumberValidation(phoneNumberForm.phoneNumber)}
                          errorMessage="Invalid phone number"
                        />
                      </div>
                      <CustomInput
                        inputLabel="Otp"
                        type="number"
                        placeholder="Enter otp"
                        name="otp"
                        value={phoneNumberForm.otp ?? ''}
                        onChangeValue={handlePhoneNumberFormChange}
                        valueRequired
                        error={!integerValidation(1, 10, phoneNumberForm.otp ?? 0)}
                        errorMessage="Invalid otp"
                      />
                      <div className="resend-otp-wrap">
                        <div className="resend-timer-wrap">
                          <span className="resend-icon">
                            <TimerIcon />
                          </span>
                          <span>00:{resendTimer < 10 ? `0${resendTimer}` : resendTimer}</span>
                        </div>
                        <p
                          role="presentation"
                          onClick={() => submitUpdatePhoneNumber('sendOtp')}
                          className={`resendOtp ${resendTimer > 0 ? 'disabled' : ''}`}>
                          Send / Resend OTP
                        </p>
                      </div>
                      <div className="form-buttons-wrap">
                        <MyButton
                          label="Cancel"
                          buttonType="back"
                          onClickFunc={togglePhoneNumberInput}
                        />
                        <MyButton
                          label="Update Phone number"
                          buttonType="submit"
                          onClickFunc={() => submitUpdatePhoneNumber('verifyOtp')}
                          disableButton={phoneNumberForm.buttonLoader}
                          loading={phoneNumberForm.buttonLoader}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
             { currentBranding === branding.VOLTIE && (
              <div className="contact-details-stripe">
                <div className="contact-header-stripe">
                  <div className="contact-icon">
                    <brandIcons.WalletIcon />
                  </div>
                  <span>Stripe ID</span>
                </div>

                <div>
                  {!editStripeIDMode ? (
                    <div className="each-contact-content-stripe">
                      <div className="content-paragraphy-stripe">
                        <p>{accountData?.stripePaymentId}</p>
                      </div>
                      <div>
                        {' '}
                        <div>
                          <Trash onClick={toggleStripeIDInput} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="contact-content-stripe">
                      <div className="iput-label-stripe">
                        <CustomInput
                          inputLabel=""
                          type="text"
                          placeholder="Enter the ID"
                          name="stripePaymentId" // Ensure this matches the key in the state
                          value={stripeIDForm.stripePaymentId}
                          onChangeValue={(name, value) => handlestripeIDFormChange(name, value)} // Ensure the handler is correctly called
                          valueRequired
                          error={!stringValidation(1, 100, stripeIDForm.stripePaymentId ?? '')}
                          errorMessage="Stripe ID is required"
                        />
                      </div>
                      <div className="Stripe-button-stripe">
                        <MyButton
                          label="Save"
                          buttonType="submit"
                          onClickFunc={updateStripeId}
                          loading={stripeIDForm.buttonLoader}
                          disableButton={stripeIDForm.buttonLoader}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div> )}
              {/* <div className="customer-care">
                <div className="customer-care-header">
                  <span>
                    <CustomerCare />
                  </span>
                  <p>Customer Care</p>
                </div>
                <div className="contact-call">
                  <MyButton
                    label="Call"
                    disableHoverEffect
                    buttonType="back"
                    onClickFunc={() => {}}
                    svgIcon={<Call />}
                  />
                </div>
                <div className="contact-chat">
                  <MyButton
                    label="Chat"
                    disableHoverEffect
                    buttonType="back"
                    onClickFunc={() => {}}
                    svgIcon={<Chat />}
                  />
                </div>
              </div> */}
            </div>
          </div>
          <RevenueDetails withdrawalHistoryChange={withdrawalHistoryChange} />
        </div>
      </div>
      <RevenueHistory />
    </div>
  );
}

export default Profile;
